import Cookies from "js-cookie";
import { getDomainName, isLocalHost } from "./env";
let cookies = Cookies.withConverter({
  write: JSON.stringify,
  read: JSON.parse
});

if (!isLocalHost(window.location.hostname)) {
  cookies = cookies.withAttributes({
    domain: `.${getDomainName()}`,
    secure: true // allows only https in prod mode

  });
}

export const set = cookies.set;
export const get = cookies.get;
export const remove = cookies.remove;
export const setForToday = (name, value, options = {}) => {
  const endOfDay = new Date();
  endOfDay.setUTCHours(23, 59, 59, 999);
  return cookies.set(name, value, { ...options,
    expires: endOfDay
  });
};
export const setFor = (name, value, options = {
  time: 10 * 60 * 60
}) => {
  const {
    time,
    otherOptions
  } = options;
  const nowDate = new Date();
  nowDate.setSeconds(time);
  return cookies.set(name, value, { ...otherOptions,
    expires: nowDate
  });
};
/** Returns the date in `n` days from today. */

export const dateFromToday = n => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d;
};